export const WATCHLIST_PUBLICATION_DISPOSITIONS = Object.freeze({
    PREPARED: 'prepared',
    OBSOLETE: 'obsolete',
});

export function parseWatchlistPublicationReceipt(value) {
    if (!value || typeof value !== 'object') {
        return null;
    }
    const receipt = value.lifecycle?.terminal_receipt ?? value.terminal_receipt ?? value;
    const rawRevisionId = receipt.watchlist_revision_id;
    const revisionId = typeof rawRevisionId === 'string'
        ? rawRevisionId.trim()
        : '';
    const revisionSeq = receipt.revision_seq;
    if (
        !revisionId
        || typeof revisionSeq !== 'number'
        || !Number.isSafeInteger(revisionSeq)
        || revisionSeq <= 0
    ) {
        return null;
    }
    return { revisionId, revisionSeq };
}

export function requirePreparedWatchlistPublication(result) {
    const prepared = result?.prepared;
    if (result?.disposition !== WATCHLIST_PUBLICATION_DISPOSITIONS.PREPARED
        || !prepared || typeof prepared.canCommit !== 'function'
        || typeof prepared.commit !== 'function' || typeof prepared.discard !== 'function') {
        throw new Error('Watchlist publication requires an owned prepared bundle.');
    }
    return prepared;
}
